import { Component, Input } from '@angular/core';
import { LazyImgDirective } from '@core-mkt/services/lazy-load/lazy-load.directive';

import { reviewData } from '../review-data';

@Component({
  selector: 'card-reviews',
  templateUrl: './card-reviews.component.html',
  styleUrls: [],
  standalone: true,
  imports: [LazyImgDirective],
})
export class CardReviewsComponent {
  @Input() backgroundInfo: any;
  @Input() textColorOverride: string;
  @Input() containerClasses: string;
  @Input() title: string;

  cardReviews = reviewData[4];

  constructor() {}
}
